import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-freelance-projects',
  templateUrl: './freelance-projects.component.html',
  styleUrls: ['./freelance-projects.component.css']
})
export class FreelanceProjectsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
